import {
  alpha,
  border,
  color,
  fontSize,
  fontWeight,
  height,
  margin,
  minWidth,
} from "@mui/system";

import { fonts, gutterX } from "../shared/ticketLayout";

const styles = (theme) => ({
  paperContainer: {
    borderRadius: "16px",
    padding: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "relative",
    overflow: "hidden",
  },
  containerHeader: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  containerNewMensagem: {
    width: "95%",
    margin: "10px auto",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    gap: 1,
  },
  paperNewMensagem: {
    width: "100%",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "0 15px",
    backgroundColor: "transparent",
  },
  boxEdit: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "50px",
    px: gutterX,
  },
  checkBox: {
    position: "absolute",
    top: 4,
    right: 4,
    borderRadius: "50%",
    padding: 0.5,
    color: theme.palette.primary.main,
  },
  containerBoxImg: {
    position: "relative",
    display: "inline-block",
    cursor: "pointer",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: `0 1px 4px ${alpha(theme.palette.colors.black.darker, 0.12)}`,
    transition: "transform 0.15s, box-shadow 0.15s",
  },
  imageCaptionOverlay: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    p: "6px 8px",
    textAlign: "left",
    background: `linear-gradient(0deg, ${alpha(
      theme.palette.colors.black.darker,
      0.85,
    )} 0%, ${alpha(theme.palette.colors.black.darker, 0)} 100%)`,
  },
  imageCaptionText: {
    color: theme.palette.white.main,
    fontSize: fonts.chip,
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  fileIconBadge: {
    width: 44,
    height: 44,
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  boxFilterColor: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    bgcolor: alpha(theme.palette.primary.main, 0.3),
    borderRadius: "8px",
  },
  buttonCancel: {
    color: theme.palette.mode !== "dark" && theme.palette.colors.black.darker,
  },
  chipStatusAnexo: {
    position: "absolute",
    top: 6,
    right: 6,
    height: "22px",
    fontSize: fonts.chip,
    fontWeight: 600,
    borderRadius: "8px",
  },
  chipStatusAnexoIcon: {
    fontSize: "13px !important",
  },
  chipPublicado: {
    backgroundColor: alpha(theme.palette.chip.background.success, 0.95),
    color: theme.palette.chip.colorText.success,
    fontWeight: "bold",
    border: `1px solid ${theme.palette.chip.colorText.success}`,
  },
  chipCliente: {
    color: theme.palette.white.main,
    fill: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
  },
  containerTitle: {
    display: "flex",
    flexDirection: "row",
    gap: 0.5,
    flex: 1,
    minWidth: 0,
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
    fontSize: "18px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  cardDescricao: {
    fontSize: fonts.body,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontWeight: "bold",
  },
  chipBody: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  nameDescription: {
    fontWeight: "bold",
    fontSize: fonts.label,
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  valueDescription: {
    fontSize: fonts.label,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  containerDataDescription: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  containerModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "1000px",
    bgcolor: "background.paper",
    boxShadow: 24,

    height: "600px",
  },
  containerIconExist: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "50px",
    height: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  conatinerLoading: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chipStatus: {
    minWidth: "120px",
    color: theme.palette.white.main,
  },
  titleModal: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "95%",
  },
  valueChip: {
    fontSize: fonts.chip,
    fontWeight: "bold",
  },
  containerHeaderModal: {
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    position: "sticky",
    top: 0,
    backgroundColor: alpha(theme.palette.background.paper, 0.8),
    px: gutterX,
    py: 2.5,
    gap: 1,
  },
  titleDescription: {
    fontSize: fonts.sectionTitle,
    fontWeight: "bold",

    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  boxBodyModal: { px: gutterX, height: "100%" },
  containerBodyModal: {
    maxHeight: "80%",
    overflowY: "auto",
  },
  containerPaperModal: {
    width: "100%",
    borderRadius: "16px",
    padding: 2,
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    flexWrap: "wrap",
    height: 550,
  },
  titleChipModal: {
    fontWeight: "bold",
    fontSize: fonts.chip,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  containerDescription: {
    width: "100%",
    minHeight: "60px",
  },
  clearIcon: {
    fontSize: "20px",
    color: theme.palette.text.main,
  },
  buttonDetails: {
    width: "80%",
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
  },
  containerPaperMensagem: {
    width: "100%",
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  bodyMensagem: { padding: 2, display: "flex", gap: 2 },
  boxImg: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
    display: "block",
    borderRadius: "8px",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
    maxWidth: "50px",
    maxHeight: "50px",
  },
  boxAnexo: {
    width: 139,
    height: 139,
    objectFit: "cover",
    display: "block",
    flexShrink: 0,
    flexGrow: 0,
    cursor: "pointer",
  },
  boxTextAnexo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "90%",
    fontSize: fonts.label,
    fontWeight: 500,
  },
  boxTitleAnexo: {
    maxWidth: "150px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    p: 1,
  },
  containerCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    gap: 0.5,
    p: 1,
  },
  chipTypeAtendimento: {
    width: "180px",
    backgroundColor: theme.palette.colors.pink.medium,
    color: theme.palette.white.main,
  },
  containerTabs: {
    width: "100%",
    bgcolor: "background.paper",
    padding: "0 2%",
  },
  buttonAnexo: {
    width: 139,
    height: 139,
    borderRadius: "12px",
    border: `1px solid ${alpha(theme.palette.text.primary, 0.12)}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: `0 1px 4px ${alpha(theme.palette.colors.black.darker, 0.12)}`,
  },
  boxWithoutImg: {
    width: 50,
    height: 50,

    display: "block",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  chip: {
    backgroundColor: theme.palette.cardTrafficData.paperColor.statusUp,
    fontWeight: "bold",
    color: theme.palette.white.main,
    marginLeft: 1,
    flexShrink: 0,
  },
  titleProtocolo: {
    fontSize: fonts.label,
    fontWeight: "bold",
  },
  boxDescription: {
    display: "flex",
    gap: 1,
  },
  description: {
    fontSize: fonts.body,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    fontWeight: "regular",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.light
        : theme.palette.colors.black.medium,
  },
  containerInfo: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyItems: "center",
  },

  icon: {
    fontSize: "20px",
  },
  boxIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    minWidth: "40px",
    height: "20px",
    padding: 1,
    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  boxFluxo: {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "40px",
    height: "20px",
    padding: 1,
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  iconStatus: { fontSize: fonts.body },
  titleStatusCard: {
    fontSize: "9px",
    fontWeight: 900,
    color: theme.palette.white.main,
  },
  containerButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10px",
  },
  boxInfos: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  containerStatusModal: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
});

export default styles;
